import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal, Row, Col } from 'react-bootstrap';
import LinksForm from './LinksForm';
import * as studentActions from '../../actions/studentsActionCreators';
// import label from '../../utils/lngEn';

class LinksModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      link: {
        title: '',
        initialValues: {
          id: '',
          courses: [],
          name: ''
        }
      },
      errorCourses: ''
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.deleteLinks = this.deleteLinks.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ link: nextProps.initial });
  }

  // Submit with custom validation for form widgets
  handleSubmit(values) {
    let runName = localStorage.getItem('run');
    let promise = new Promise((resolve) => {
      if (values.courses.length == 1) {
        this.setState({ errorCourses: 'Can not link single class' });
      } else if (values.courses.length == 0 || values.courses == null) {
        this.setState({ errorCourses: 'Required' });
      } else {
        this.setState({ errorCourses: null });
      }
      return resolve();
    });
    promise.then(() => {

      return new Promise((resolve, reject) => {
        if (this.state.errorCourses !== null) {
          return reject();
        } else {
          return resolve();
        }
      });
    }).then(() => {
      let obj = {};
      if (values.courses.length == 0) {
        this.deleteLinks(this.props.student.links[0].id);
      } else {
        if (typeof (values.courses[0]) == 'object') {
          obj.courses = values.courses.map(c => {
            return c.id;
          });
        } else {
          obj.courses = values.courses;
        }
        if (typeof (values.limit) == 'object') {
          obj.limit = +values.limit.value;
        } else {
          obj.limit = +values.limit;
        }

        // Edit link
        obj.id = values.id || '';
        let requestMethod = values.id ? 'PUT' : 'POST';
        let open_edit_api = values.id ? '/runs/' + runName + '/limit-preferences/' + obj.id + '/' :
          '/runs/' + runName + '/limit-preferences/';
        obj.name = values.name;
        this.props.studentActions.updateLinks(requestMethod, open_edit_api, obj).
          then((res) => {
            this.props.closeModal();
            if (this.props.updateLimitPreferenceTable) {
              this.props.updateLimitPreferenceTable(res.data);
            }
          }).catch(err => {
            console.log('err', err);
          });
      }

    })
      .catch(() => {
        console.log('error on the form');
      });
  }

  // Remove all links
  deleteLinks(linksId) {
    if (linksId) {
      this.props.studentActions.deleteLinks(linksId)
        .then(() => {
          this.props.closeModal();
        });
    } else {
      this.props.closeModal();
    }

  }

  render() {
    // Links object has an Id
    // let id = this.props.student.links[0] ? this.props.student.links[0].id : null;
    return (
      <Modal show={this.props.showModal} onHide={this.props.closeModal} backdrop="static" className="linksModal" bsSize="large">
        <Modal.Header closeButton>
          <Modal.Title>
            <Row>
              <Col md={12} className="modal-title">
                {this.state.link.title}

              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <Row>
            <Col md={12}>
              <div className="pull-left"><p className="font-size-16">{label.linksModal_body}</p></div>
              <button
                className="btn btn-ter pull-right mt-1"
                onClick={() => {this.deleteLinks(id)}}
                disabled={!this.props.student.links[0]}
              >Delete All Links</button>
            </Col>
          </Row> */}
          <LinksForm
            onSubmit={this.handleSubmit}
            onCancel={this.props.onCancel}
            initialValues={this.state.link.initialValues}
            coursesArray={this.props.initial.coursesArray}
            errorCourses={this.state.errorCourses}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

LinksModal.propTypes = {
  //myProp: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  return {
    courses: state.courses,
    student: state.student
  };
}

function mapDispatchToProps(dispatch) {
  return {
    studentActions: bindActionCreators(studentActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LinksModal);



// WEBPACK FOOTER //
// ./src/components/rank/LinksModal.js